import { useEffect, useRef, useState } from 'react';
import { PasswordCriteria } from '../authentication/PasswordCriteria';
import revealPassword from '../../assets/icons/reveal-password.svg';
import closeIcon from '../../assets/icons/close-icon.svg';
import changePasswordIcon from '../../assets/icons/password-icon.svg';

interface Props {
  setModalOn: (modalOn: boolean) => void;
}

export const AccountSettings = (props: Props) => {
  const [revealPasswordBtn, setRevealPasswordBtn] = useState<boolean>(false);
  const [passwordValue, setPasswordValue] = useState<string>('');
  const [showPasswordCriteria, setShowPasswordCriteria] = useState<boolean>(false);
  const [changePassword, setChangePassword] = useState<boolean>(false);

  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!modalRef.current?.contains(event.target as Node)) {
        props.setModalOn(false);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);

    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        props.setModalOn(false);
      }
    };
    document.addEventListener('keydown', handleEsc);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <div className='modal-active dark-100'>
      <div className='main-modal'>
        <div className='padding-bottom-5' ref={modalRef}>
          <form className='form modal-form relative'>
            <h3 className='font-h3-regular'>Account settings</h3>
            <img className='modal-form__close' src={closeIcon} alt='' onClick={() => props.setModalOn(false)} />
            <div className='form__item'>
              <label className='font-h6-regular margin-left-1' htmlFor='firstName'>
                First name
              </label>
              <input className='form__item__input font-h5-regular' type='text' />
            </div>
            <div className='form__item relative margin-bottom-0'>
              <label className='font-h6-regular margin-left-1' htmlFor='lastName'>
                Last name
              </label>
              <input className='form__item__input font-h5-regular'></input>
              <div className='full-width-grey-300-line' />
            </div>

            {!changePassword ? (
              <div onClick={() => setChangePassword(!changePassword)}>
                <img src={changePasswordIcon} alt='' />
                <span className='margin-left-1 font-h5-regular'>Change password</span>
              </div>
            ) : (
              <>
                <div className='form__item relative'>
                  <label className='font-h6-regular margin-left-1' htmlFor='email'>
                    Old password
                  </label>
                  <input className='form__item__input font-h5-regular' type={revealPasswordBtn ? 'text' : 'password'}></input>
                  <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
                </div>
                <div className='form__item relative'>
                  <label className='font-h6-regular margin-left-1' htmlFor='email'>
                    New password
                  </label>
                  <input
                    className='form__item__input font-h5-regular'
                    onChange={(e) => {
                      setPasswordValue(e.target.value);
                    }}
                    type={revealPasswordBtn ? 'text' : 'password'}
                    onClick={() => setShowPasswordCriteria(true)}
                  ></input>
                  <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
                  <PasswordCriteria passwordValue={passwordValue} showPasswordCriteria={showPasswordCriteria} />
                </div>
                <div className='form__item relative'>
                  <label className='font-h6-regular margin-left-1' htmlFor='email'>
                    Repeat new password
                  </label>
                  <input className='form__item__input font-h5-regular' type={revealPasswordBtn ? 'text' : 'password'}></input>
                  <img className='form__item__img' src={revealPassword} onClick={() => setRevealPasswordBtn(!revealPasswordBtn)} alt='revPass' />
                </div>
              </>
            )}
            <div className='text-right margin-top-3'>
              <span className='font-h5-medium button-tertionary' onClick={() => props.setModalOn(false)}>
                Cancel
              </span>
              <button type='submit' className='button-primary margin-left-2'>
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
